'use client'

import React from 'react'
import Image from 'next/image'
import styles from './styles.module.css'
import { getStrapiImageUrl } from '@/lib/strapi'
import { processStrapiTextTags } from '@/components/StrapiContentRenderer'

interface MediaImage {
  url?: string
  alternativeText?: string
  data?: {
    attributes?: {
      url?: string
      alternativeText?: string
    }
  }
}

interface MainBlockData {
  titlle_h1?: string
  description?: string
  image?: MediaImage
}

interface MainBlockProps {
  data: MainBlockData
}

const extractImageUrl = (img?: MediaImage): { url: string; alt: string } => {
  if (!img) return { url: '', alt: '' }

  if (img.data?.attributes?.url) {
    return {
      url: getStrapiImageUrl(img.data.attributes.url),
      alt: img.data.attributes.alternativeText || ''
    }
  }

  if (img.url) {
    return {
      url: getStrapiImageUrl(img.url),
      alt: img.alternativeText || ''
    }
  }

  return { url: '', alt: '' }
}

const MainBlock: React.FC<MainBlockProps> = ({ data }) => {
  const image = extractImageUrl(data.image)
  const processedTitle = data.titlle_h1 ? processStrapiTextTags(data.titlle_h1) : ''

  return (
    <section className={styles.main}>
      <div className={styles.content}>
        {processedTitle && (
          <h1 
            className={styles.title}
            dangerouslySetInnerHTML={{ __html: processedTitle }}
          />
        )}
        {data.description && (
          <p className={styles.description}>{data.description}</p>
        )}
      </div>
      {image.url && (
        <div className={styles.visual}>
          <Image
            src={image.url}
            alt={image.alt || data.titlle_h1 || ''}
            width={1110}
            height={500}
            className={styles.image}
            priority
          />
        </div>
      )}
    </section>
  )
}

MainBlock.displayName = 'MainBlock'

export default MainBlock

